import { IApiSettings } from "../interfaces/index";
import RollbarErrorTracking from "../helpers/RollbarErrorLog";

export class ApiError extends Error {
  body: any;

  constructor(body: any) {
    super(`Fetch did not return OK status : ${JSON.stringify(body)}`);
    this.body = body;
  }
}

export enum definedRouteTypes {
  upload = "upload",
  editorialNews = "jaunumi",
  diasporeNews = "mediju-jaunumi",
  organizationNews = "organizaciju-jaunumi",
  events = "notikumi",
  pastEvents = "aizvaditie-notikumi",
  imageGallery = "attelu-galerijas",
  videoNews = "video-galerijas",
  offers = "piedavajumi",
  organizations = "organizacijas",
  search = "search",
  dynamic = "dynamic",
  footer = "static",
  orgSlugs = "orgSlugs",
  pictures = "pictures",
  companies = "uznemumi",
  selfEmployed = "profesionali",
  companyNews = "uznemumu-jaunumi",

  SOURCE_MEDIA = "mediju-avoti",
  LINK_MEDIA = "mediju-saites",
}

export enum definedHomePageRoutes {
  news = "home-news",
  organizations = "home-orgs",
  events = "home-events",
}

export enum definedUnapprovedRoutes {
  news = "new-news",
  events = "new-events",
  organizations = "new-orgs",
  links = "new-media-links",
}

export enum definedFooterRoutes {
  contacts = "kontakti",
  about = "par-mums",
  tos = "lietosanas-noteikumi",
  forOrganizations = "organizacijam",
  partners = "atbalstitaji",
  nightingale = "lakstigala",
  instructions = "lietosanas-pamaciba",
}

export enum ContentStatusTypes {
  active = "active",
  toBePosted = "toBePosted",
  archived = "archived",
}

export enum definedPictureType {
  type = "type",
}

// TODO: Fix (body:any) @Dainis
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PostSettings = (body: any, token: string) => ({
  method: "POST",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: token,
  },
  body: JSON.stringify(body),
});

// TODO: Fix (body:any) @Dainis
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PutSettings = (body: any, token: string) => ({
  method: "PUT",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: token,
  },
  body: JSON.stringify(body),
});

// TODO: Fix (body:any) @Dainis
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DeleteSettings = (body: any, token: string) => ({
  method: "DELETE",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: token,
  },
  body: JSON.stringify(body),
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GetSettings = (headers: Record<string, string> = {}) => ({
  method: "GET",
  headers: {
    Accept: "*/*",
    ...headers,
  },
});

export enum definedErrors {
  slugExists = "SLUG exists",
  noImagesInGallery = "Gallery should contain at least one image.",
}

export async function handleApi(
  url: string,
  settings: IApiSettings,
  skipResponseStream = false,
) {
  const response = await fetch(url, settings);

  if (skipResponseStream) {
    // this is necessary for presignS3 fetches
    if (response.status !== 200) {
      throw new ApiError(response);
    }

    return response;
  }

  const data = await response.json();
  if (response.status !== 200 || data?.errorType || data?.errorMessage) {
    const error = new ApiError(data);
    RollbarErrorTracking.logErroInfo(error.message);
    RollbarErrorTracking.logErrorInRollbar(error.message);
    throw error;
  }
  return data;
}

export function handleApiGet(
  url: string,
  headers: Record<string, string> = {},
) {
  return handleApi(url, GetSettings(headers));
}
// TODO: Fix (body:any) @Dainis
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function handleApiPost(url: string, idToken: string, body: any) {
  const settings = PostSettings(body, idToken);
  return handleApi(url, settings);
}

export async function handleApiDelete(
  url: string,
  idToken: string,
  slug: string,
  imageUrl?: string,
) {
  const settings = DeleteSettings({ slug, imageUrl }, idToken);
  return handleApi(url, settings);
}

export async function handleApiDeletePicture(
  url: string,
  idToken: string,
  body: any,
) {
  const settings = DeleteSettings(body, idToken);
  return handleApi(url, settings);
}

// TODO: Fix (body:any) @Dainis
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function handleApiPut(url: string, idToken: string, body: any) {
  const settings = PutSettings(body, idToken);
  return handleApi(url, settings);
}
